<template>
  <Info />
  <Logo />
  <Join />
</template>
<script setup>
import Info from "@sections/about/info.vue";
import Logo from "@sections/about/logo.vue";
import Join from "@sections/home/join.vue";
</script>
